import { FormSubmitHandler } from '@arpeggi/ui/src/primitives/Form/types'
import { useSnackbar } from 'notistack'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { InternalEndpoint } from '../../../__legacy__/components/Internal'
import { useCreateRedirect } from '../queries'
import { CreateRedirectFormFields } from '../types'

export const useCreateRedirectForm = () => {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const createRedirectMutation = useCreateRedirect()
  const form = useForm<CreateRedirectFormFields>({
    mode: 'onChange'
  })

  const onSubmit: FormSubmitHandler<CreateRedirectFormFields> = (dto) => {
    createRedirectMutation.mutate(dto, {
      onSuccess: () => {
        enqueueSnackbar('Redirect created!', {
          variant: 'modalSuccess'
        })
        navigate(`/${InternalEndpoint}/redirects`)
      }
    })
  }

  return { form, onSubmit, createRedirectMutation }
}
